import {EmailData} from './EmailData'

export type InviteUserEmailData = EmailData & {
    username: string
    firstName: string
    password: string
    passwordValidDays: string,
}
